import React from 'react';
import { motion } from 'framer-motion';
import bglogo from "../assets/images/fastest-logo.png";
import laptop from "../assets/images/businessman-working-laptop 1.png";
import arrowup from "../assets/images/p_arrow-rt.png";
import { NavLink } from 'react-router-dom';

export default function LetsBegin() {
    return (
        <>
            <section className='py-[4%] px-[8%]'>
                <div className='grid lg:grid-cols-2'>

                    {/* Left Section with Logo and Text Animation */}
                    <motion.div
                        className='bg-[#002455]'
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ type: 'spring', stiffness: 100, damping: 25 }}
                    >
                        <div className="relative">
                            <motion.div
                                className='absolute left-[32%]'
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.2, duration: 0.8 }}
                            >
                                <img src={bglogo} alt="logo" className='w-[65%]' />
                            </motion.div>

                            <motion.h3
                                className='px-8 py-12 text-white font-[800] leading-[1.5] text-[2rem]'
                                initial={{ opacity: 0, y: -50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3, duration: 0.8 }}
                            >
                                Let's <br /><span className='relative text-[var(--second-primary-color)] lets_begin'>Begin</span>
                            </motion.h3>

                            <motion.div
                                className='text-[.9rem] text-[#FFFFFF] px-8 py-8'
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                transition={{ delay: 0.4, duration: 1 }}
                            >
                                <p className='pb-3'>Fastest aims to revolutionize the way we think about money transfers by making them instant, secure, and accessible to everyone, everywhere.</p>
                                <p>With a strong focus on user experience and innovation, Fastest is poised to become a leader in the global money transfer industry.</p>
                                <motion.button
                                    className='mt-10 px-8 py-[9px] bg-gradient-to-r from-black to-[#06069a] opacity-70 text-[.9rem] text-[#2AD5FF] border border-1 border-[var(--primary-color)] rounded-md hover:bg-gray-100 transition duration-200'
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <NavLink to="https://app.fastest.exchange/login">
                                    Get Started
                                    </NavLink>
                                </motion.button>
                            </motion.div>
                        </div>
                    </motion.div>

                    {/* Right Section with Image Animation */}
                    <motion.div
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ type: 'spring', stiffness: 100, damping: 25 }}
                    >
                        <img src={laptop} alt="laptop" className='w-[500px]' />
                    </motion.div>
                </div>
            </section>

            {/* Email Section with Animated Arrow */}
            <section className='mb-[6%]'>
                <div className='py-16'>
                    <motion.h3
                        className='w-full text-[#002455] text-center text-[1.5rem] font-[700] leading-[1]'
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                    >
                        Get rates delivered to you in your <span className='relative text-[var(--second-primary-color)] box'>inbox</span>
                    </motion.h3>
                </div>

                <div className='md:w-[20%] w-[50%] m-[auto] mb-4 border-b-[1px] border-[var(--primary-color)]'>
                    <motion.p
                        className='flex justify-between text-[#70798D] text-center text-[.9rem] leading-[2] pl-4'
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.6, duration: 0.8 }}
                    >
                        <span>Email</span>
                        <motion.i
                            className="flex justify-center items-center ml-6 h-[20px] w-[20px] rounded-full bg-[var(--primary-color)]"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.7, duration: 0.6 }}
                        >
                            <img src={arrowup} alt="arrow" />
                        </motion.i>
                    </motion.p>
                </div>
            </section>
        </>
    );
}
